import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class WoodenBridgeTileEntity2 extends TileEntity {
	public static readonly frameName = FrameName.WOODEN_BRIDGE_2;
}

export default WoodenBridgeTileEntity2;
